export const LV_ShipmentAddressAllTR={
ShAdID:{en:'Address ID',cs:'ShAdID',dataType:'number',format:'#0',required:true},
ShAdAddress:{en:'Address',cs:'Adresa',dataType:'string',maxLength:510},
ShAdZIPCode:{en:'ZIP Code',cs:'PSČ',dataType:'string',maxLength:510},
_ShAdAllText:{en:'_ShAdAllText',cs:'_ShAdAllText',dataType:'string',maxLength:1021},
ShAdTimeStamp:{en:'ShAdTimeStamp',cs:'ShAdTimeStamp',dataType:'number',format:'#0'},
ShAdShASID:{en:'Country',cs:'Stát',dataType:'number',format:'#0'},
ShAdName:{en:'Name',cs:'Unikátní jméno',dataType:'string',maxLength:255},
ShAdNameFull:{en:'Full Name',cs:'Celé jméno',dataType:'string',maxLength:255},
ShAdNameAddition:{en:'Name Addition',cs:'Jméno extra',dataType:'string',maxLength:255},
ShAdHouseNumber:{en:'House Number',cs:'Číslo popisné',dataType:'string',maxLength:50},
ShAdAddressAddition:{en:'Address Addition',cs:'Dopňujicí info',dataType:'string',maxLength:255},
ShAdRegion:{en:'Region',cs:'Region',dataType:'string',maxLength:255},
ShAdCity:{en:'City',cs:'Město',dataType:'string',maxLength:255},
ShAdContinent:{en:'Continent',cs:'Kontinent',dataType:'string',maxLength:100},
ShASName:{en:'Country Name',cs:'Název státu',dataType:'string',maxLength:100},
ShASCode:{en:'Country Code',cs:'Kód státu',dataType:'string',maxLength:3}
}